import Swiper, { Navigation, Scrollbar } from 'swiper/core';
Swiper.use([Navigation, Scrollbar]);

function checkArrow(scrollbar, nextArrow, prevArrow) {
    if (scrollbar.style.display === 'none') {
        prevArrow.style.display = 'none';
        nextArrow.style.display = 'none';
    } else {
        prevArrow.style.display = 'block';
        nextArrow.style.display = 'block';
    }
}

export default class ImageGridSlider {
    constructor(elm, args) {
        if (elm.querySelectorAll('.swiper-slide').length === 0) return;

        let nextArrow = elm.parentNode.querySelector('.swiper-button-next');
        let prevArrow = elm.parentNode.querySelector('.swiper-button-prev');
        let scrollbar = elm.parentNode.querySelector('.swiper-scrollbar');

        let options = {
            spaceBetween: 5,
            allowTouchMove: true,
            slidesPerView: 1.2,
            slideNextClass: 'swiper-slide-next',
            observer: true,
            observeParents: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
                992: {
                    slidesPerView: 3,
                },
                600: {
                    slidesPerView: 2.2,
                },
            },
            navigation: {
                nextEl: nextArrow,
                prevEl: prevArrow,
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                snapOnRelease: true,
            },
            on: {
                init: function () {
                    setTimeout(() => {
                        checkArrow(scrollbar, nextArrow, prevArrow);
                    }, 1);
                },
                resize: function () {
                    checkArrow(scrollbar, nextArrow, prevArrow);
                },
            },
        };

        let swiper = new Swiper(elm, options);
    }

    update() {
        this.swiper.update();
    }

    destroy() {
        this.swiper.destroy();
    }
}
